module.exports = {
    SWEEPS_INPUT: /^[\w\-\s]+$/,
    EMAIL_VALIDATION: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
};



// WEBPACK FOOTER //
// ./app/scripts/constants/_regex.js